var map = {
	"./aduan/allegations.vue": [
		"B9VP",
		0
	],
	"./aduan/single-allegations.vue": [
		"h7pr",
		9
	],
	"./config/allegation-categories.vue": [
		"GEUO",
		1
	],
	"./config/permissions.vue": [
		"qNA3",
		7
	],
	"./config/role-group.vue": [
		"b4A/",
		6
	],
	"./config/role.vue": [
		"EQk+",
		12
	],
	"./config/users.vue": [
		"6T7N",
		2
	],
	"./dashboard/main-dashboard.vue": [
		"gBpN",
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ufig";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/modules lazy ^\.\/.*\.vue$
// module id = ufig
// module chunks = 15